import { render } from "./MediumApi.vue?vue&type=template&id=7a5d7b4c&scoped=true"
import script from "./MediumApi.vue?vue&type=script&lang=js"
export * from "./MediumApi.vue?vue&type=script&lang=js"

import "./MediumApi.vue?vue&type=style&index=0&id=7a5d7b4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5d7b4c"]])

export default __exports__